import { useEffect } from "react";
import { Outlet, useNavigate, useOutletContext } from "react-router-dom";

export function Admin() {
    const { user, organization, csrfToken, channels, campaigns, companyPages, orgID, importSharesMaxImportCount, importSharesMaxAgeDays } = useOutletContext()
    const navigate = useNavigate()
    const isAdmin = user?.UserType?.Name === "admin"
    const isSuperAdmin = user?.UserType?.Name === "super_admin"
    const isAdminPageAllowed = isAdmin || isSuperAdmin

    useEffect(() => {
        if (!isAdminPageAllowed) {
            navigate("../not-found", { relative: "path" })
        }
    }, [isAdminPageAllowed, navigate])

    return (
        isAdminPageAllowed && <Outlet context={{ user, organization, csrfToken, channels, campaigns, companyPages, orgID, importSharesMaxImportCount, importSharesMaxAgeDays }} />
    )
}
